/** @typedef {import('./Types/BlogsWidgetProps').default} Props */

import { translate } from '../../../Internationalization';
import BlogsEmbed from './BlogsEmbed';
import CopyAgentBlogScript from './CopyAgentBlogScript/CopyAgentBlogScript';
import flags from '../../../../shared/Flags';
import GatedBlogs from './GatedBlogs/GatedBlogs';
import images from '../../../../config/local/images';
import Loading from '../../../../shared/Loading';
import React from 'react';
import useIsGated from '../../../../Hooks/Shared/useIsGated/useIsGated';
import WidgetHeader from '../Header/WidgetHeader';

const title = (
	<h2 className="hl-ms-4 mb-4">
		{translate('agent.pages.widgets.blog.title')}
	</h2>
);

const widgetHeader = (
	<WidgetHeader
		description={translate('agent.pages.widgets.blog.description')}
		illustration={images.blog.widget.header}
		title={translate('agent.pages.widgets.blog.cta')}
	/>
);

/** @returns {JSX.Element} */
function BlogsWidget() {
	const { isGated, isGettingData } = useIsGated(flags.agent.blogWidget);

	if (isGettingData) {
		return (
			<main>
				{widgetHeader}
				{title}
				<Loading />
			</main>
		);
	}

	if (isGated) {
		return (
			<main>
				{widgetHeader}
				{title}
				<GatedBlogs />
			</main>
		);
	}

	return (
		<main>
			{widgetHeader}
			<CopyAgentBlogScript />
			{title}
			<BlogsEmbed />
		</main>
	);
}

export default React.memo(BlogsWidget);
